import { PaymentSystem } from './PaymentSystem';

export enum SubscriptionStatus {
  None = 'None',
  Signed = 'Signed',
  Canceled = 'Canceled',
  WaitingSigned = 'WaitingSigned'
}

export class ProviderData {
  CompanyName: string;
  Id: string;
  Phone: string;
  /** Email used for receive notification or just contact with provider */
  EmailNotificationsTo: string;
  RemoteAccessEnabled: boolean;
  TimeZoneSpecified?: boolean;
  TimeZone: string;
  TimeZoneOffset: number;
  TimeZoneDisplayName: string;
  SubscriptionStatus: SubscriptionStatus;
  SubscriptionCurrencySign: string;
  PaymentSystem: PaymentSystem;
  IsPostPayment: boolean;
  Balance: string;
  PasswordRecoveryEnabled: boolean;
  LicenseMode: LicenseMode;
}

export enum LicenseMode {
  None = 'None',
  Monthly = 'Monthly',
  CumulativeV2Monthly = 'CumulativeV2Monthly',
  CumulativeV3Monthly = 'CumulativeV3Monthly',
  CumulativeV4Monthly = 'CumulativeV4Monthly',
  Yearly = 'Yearly',
  CumulativeV2Annual = 'CumulativeV2Annual',
  CumulativeV3Annual = 'CumulativeV3Annual',
  CumulativeV4Annual = 'CumulativeV4Annual'
}
